import { Component, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/app.service';
import { BancosService } from 'src/app/services/bancos.service';
import { DadosCargasService } from 'src/app/services/dados-cargas.service';

@Component({
    selector: 'app-modal-atualiza-bancos',
    templateUrl: './modal-atualiza-bancos.component.html',
    providers: [BancosService]
})

export class ModalAtualizaBancosComponent implements OnInit {

    modalRef: NgbModalRef;
    public banco: any;

    constructor(
        private appService: AppService,
        private bancosService: BancosService,
        private spinner: NgxSpinnerService,
        public toastrService: ToastrService,
        private dadosCargasService: DadosCargasService
    ) { }

    ngOnInit(): void {
        this.banco = this.modalRef.componentInstance.banco;
    }

    atualizar() {
        this.update(this.banco);
    }

    update(banco) {
        this.spinner.show();
        this.toastrService.clear();

        this.bancosService.update(banco)
            .subscribe(res => {
                this.toastrService.success("Banco atualizado!.", "Sucesso");
                this.modalRef.close({ result: true, page: this.modalRef.componentInstance.page, acao: 'atualizado' });
            }, error => {
                if (error && error.errors) {
                    this.toastrService.error(error.errors[0], 'Atenção', { timeOut: 10000 });
                }
                else {
                    this.toastrService.error('Não foi possível atualizar o banco!', 'Atenção', { timeOut: 10000 });
                }
                this.spinner.hide();
            });
    }

    close() {
        this.modalRef.close();
    }

    dismiss() {
        this.modalRef.dismiss();
    }
}